import styled, { css } from "styled-components";

const common = css`
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  text-align: left;
`;

export const Button = styled.button`
  ${common};
  background: white;
  border: 1px solid ${({ theme }) => theme.primary};
  padding: 0.5rem;
  margin: 0.5rem;
  font-size: 1rem;
  min-width: 3rem;
  color: ${({ theme }) => theme.primary};
  &:hover {
    background: ${({ theme }) => theme.primary};
    color: white;
  }
  ${({ active }) =>
    active &&
    css`
      background: ${({ theme }) => theme.primary};
      color: white;
    `};
`;

export default Button;

export const LargeButton = styled.button`
  ${common};
  background: ${({ theme, secondary }) => (secondary ? theme.secondary : theme.primary)};
  border: 1px solid ${({ theme, secondary }) => (secondary ? theme.secondary : theme.primary)};
  padding: 12px 20px;
  font-size: 18px;
  line-height: 21px;
  text-transform: uppercase;
  font-weight: 800;
  color: white;
  width: ${({ width }) => (width ? width : "auto")};

  &:hover {
    opacity: 0.8;
  }
`;
